import {Settings} from 'luxon';

export default defineNuxtPlugin({
  setup(nuxtApp) {
    const locale = (nuxtApp.$i18n as any).locale.value;

    Settings.defaultLocale = locale;
    nuxtApp.vueApp.config.globalProperties.$formkit.setLocale(locale);
  },

  hooks: {
    'i18n:localeSwitched'({newLocale}) {
      const nuxtApp = useNuxtApp();

      Settings.defaultLocale = newLocale;
      nuxtApp.vueApp.config.globalProperties.$formkit.setLocale(newLocale);
    },
  },
});
